/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SystemPromptItemDto
 */
export interface SystemPromptItemDto {
    /**
     * 
     * @type {string}
     * @memberof SystemPromptItemDto
     */
    systemPrompt: string;
}

/**
 * Check if a given object implements the SystemPromptItemDto interface.
 */
export function instanceOfSystemPromptItemDto(value: object): value is SystemPromptItemDto {
    if (!('systemPrompt' in value) || value['systemPrompt'] === undefined) return false;
    return true;
}

export function SystemPromptItemDtoFromJSON(json: any): SystemPromptItemDto {
    return SystemPromptItemDtoFromJSONTyped(json, false);
}

export function SystemPromptItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SystemPromptItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'systemPrompt': json['systemPrompt'],
    };
}

export function SystemPromptItemDtoToJSON(json: any): SystemPromptItemDto {
    return SystemPromptItemDtoToJSONTyped(json, false);
}

export function SystemPromptItemDtoToJSONTyped(value?: SystemPromptItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'systemPrompt': value['systemPrompt'],
    };
}

